import defaultProfilePicture from "assets/images/icons/icon-admin-profile.svg";

export const DEFAULT_USER_PROFILE_PICTURE = defaultProfilePicture;
